<template>
<div class="card float-e-margins">
  <div class="card-content no-padding">

    <!-- wizard steps  -->
    <vs-wizard :current-index.sync="currentStep">
      <vs-wizard-step 
        title="Winkelwagen" 
        description=""
        :progress="progress.step1"
        icon="shopping-cart">
      </vs-wizard-step>
      <vs-wizard-step 
        title="Uw gegevens" 
        description="" 
        :progress="progress.step2"
        icon="user">
      </vs-wizard-step>
      <vs-wizard-step 
        title="Bevestigen" 
        description="" 
        :progress="progress.step3"
        icon="check">
      </vs-wizard-step>
    </vs-wizard>
    <hr class="hidden-xs-down">

    <!-- Step 1 : Shopping cart -->
    <form class="m-b row clearfix" v-if="currentStep == 0">
      <div class="col-xs-12">
        <h1>Winkelwagen</h1>
        <div class="row">
        <v-cart></v-cart>
        <button class="btn btn-success pull-right" :disabled="store.cart.length < 1" @click.prevent="currentStep++">Verder</button>
        </div>
        <hr>
        <!-- <div class="row">
          <div v-for="randomproduct in randomproducts" class="col-sm-4 col-xs-12">
            <div class="thumbnail">
              <a v-link="{ name: 'Product', params: { id: randomproduct.ProductId, pname: $options.filters.slugurl(randomproduct.Name) }}">
                <img class="img-responsive" style="max-height:100px;" 
                :src="randomproduct.Photos[0].URL" alt="">
                <div class="wrapper">
                  <div class="caption post-content">
                      <h4>{{randomproduct.Name}}</h4>
                  </div>
                </div>
              </a>
              <div class="wrapper">
                  <div class="post-meta">
                      <div class="price">{{randomproduct.Price | currencyDisplay}}</div>
                  </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </form>

    <!-- Step 2: Customer information -->
    <validator name="customerValidation">
      <form novalidate class="m-b row clearfix" v-if="currentStep == 1">
        <div class="col-sm-12">
          <div class="col-xs-12 col-sm-6">
            <h1>
              Persoonlijke gegevens
            </h1>
            <fieldset class="form-group" :class="{ 'has-error': checkSex }">
              <div class="col-sm-12">
                <label for="optradio">Aanhef*</label> <br>
                <label class="radio-inline">
                <input type="radio" name="optradio" value="Dhr." v-model="invoice.customer.sex" v-validate:sex="{ required: true }">Dhr.
                </label>
                <label class="radio-inline">
                <input type="radio" name="optradio" value="Mevr." v-model="invoice.customer.sex" v-validate:sex>Mevr.
                </label>
              </div>
            </fieldset>
            <fieldset class="form-group" :class="{ 'has-error': checkFirstname }">
              <div class="col-sm-12">
                <label for="firstname">Voornaam*</label>
                <input autocomplete="off" type="text" class="form-control" id="firstname" v-validate:firstname="['required']" v-model="invoice.customer.firstname">
              </div>
            </fieldset>
            <fieldset class="form-group" :class="{ 'has-error': checkLastname }">
              <div class="col-sm-12">
                <label for="lastname">Achternaam*</label>
                <input autocomplete="off" type="text" class="form-control" id="lastname" v-validate:lastname="['required']" v-model="invoice.customer.lastname">
              </div>
            </fieldset>
            <fieldset class="form-group" :class="{ 'has-error': checkEmail }">
              <div class="col-sm-12">
                <label for="email">E-mailadres*</label>
                <input autocomplete="off" type="email" class="form-control" id="email" v-validate:email="['email']" v-model="invoice.customer.email">
              </div>
            </fieldset>
            <h1>
              Adres
            </h1>
            <fieldset class="form-group col-sm-8" :class="{ 'has-error': checkStreet }">
              <label for="street">Straatnaam*</label>
              <input autocomplete="off" type="text" class="form-control" id="street" v-validate:street="['required']" v-model="invoice.customer.street">
            </fieldset>
            <fieldset class="form-group col-sm-2 col-xs-6" :class="{ 'has-error': checkHousenumber }">
              <label for="housenumber">Huisnummer*</label>
              <input autocomplete="off" type="text" class="form-control" id="housenumber" v-validate:housenumber="['required', 'housenumber']" v-model="invoice.customer.housenumberr">
            </fieldset>
            <fieldset class="form-group col-sm-2 col-xs-6">
              <label for="housenumberaddition">Toevoeging</label>
              <input autocomplete="off" type="text" id="housenumberaddition" class="form-control" v-model="invoice.customer.housenumberaddition">
            </fieldset>
            <fieldset class="form-group col-sm-12 col-xs-12">
              <label for="remark">Opmerking</label>
              <input autocomplete="off" type="text" class="form-control" id="remark" v-model="invoice.customer.remark">
            </fieldset>
            <fieldset class="form-group col-sm-6" :class="{ 'has-error': checkZip }">
              <label for="zipcode">Postcode*</label>
              <input @blur="removeSpaces()" autocomplete="off" type="text" class="form-control" id="zipcode" v-validate:zip="['required', 'dutchzip']" v-model="invoice.customer.zipcode">
              <label for="zipcode" class="text-danger">Living outside the Netherlands?
                <br>
                Please fill in 4902PP and contact us.</label>
            </fieldset> 
            <fieldset class="form-group col-sm-6" :class="{ 'has-error': checkCity }">
              <label for="city">Plaatsnaam*</label>
              <input autocomplete="off" type="text" class="form-control" id="city" v-validate:city="['required']" v-model="invoice.customer.city">
            </fieldset>
            <p class="col-sm-12"><strong>* Verplichte velden</strong></p>      
          </div>
        </div>
        <div class="col-sm-12">
            <button class="btn btn-success pull-right" :disabled="$customerValidation.invalid" @click.prevent="GoToConfirm()">Verder</button>    
        </div>
      </form>
    </validator>

    <!-- Step 3: Agreement -->
    <div class="m-b row clearfix" v-if="currentStep == 2">
      <div class="row">
        <v-confirm :invoice.sync="invoice"></v-confirm>
      </div>
      <div class="pull-right">
        <div class="checkbox">
          <label><input id="confirmbox" type="checkbox" v-model="confirmed" :disabled="sending" :class="{ hidden : sended }">
          Ik ga akkoord met de <a v-link="{ name: 'algemeneVoorwaarden'}" target="_blank">algemene voorwaarden</a>
          </label>
        </div>
        <button id="sendButton" class="btn btn-lg btn-warning" :disabled="sending || !confirmed" @click="handleInvoice()">
          <span v-if="sending" class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span>
          verzenden
        </button>
      </div>
    </div>
      <vc-alert v-if="success" type="success"> Je bestelling is ontvangen je krijgt op het opgegeven e-mailadres een bevestiging hiervan.
        <br> Mail niet ontvangen? Check je ongewenste mail folder of neem contact op met ons via info@catootjeskraam.nl
        <br>
        <a href="/">klik hier om verder te winkelen</a>
      </vc-alert>
  </div>
</div>
</template>

<script>
import cart from './cart'
import store from '../../store'
import wizard from '../wizard/wizard'
import wizardstep from '../wizard/wizard-step'
import confirm from './confirm'
import callbackalert from '../Common/CallbackAlert'
import shippingRatesData from '../../assets/shippingRates.json'

export default {
  route: {
    canReuse: false
  },
  components: {
    'v-cart': cart,
    'v-confirm': confirm,
    'vs-wizard': wizard,
    'vs-wizard-step': wizardstep,
    'vc-alert': callbackalert
  },
  data () {
    return {
      store: store,
      // randomproducts: {},
      invoice: {
        customer: {
          sex: '',
          firstname: '',
          lastname: '',
          email: '',
          street: '',
          housenumber: '',
          housenumberr: '',
          housenumberaddition: '',
          zipcode: '',
          city: ''
        },
        shipCosts: shippingRatesData.shipping_rates[0].price,
        products: []
      },
      progress: {
        step1: 0,
        step2: 0,
        step3: 0
      },
      currentStep: 0,
      confirmed: false,
      sending: false,
      success: false,
      sended: false
    }
  },
  created () {
    // step 1
    var self = this
    if (self.currentStep === 0) {
      self.progress.step1 = 0
      setTimeout(function () {
        if (self.store.cart.length > 0) {
          self.progress.step1 = 100
        }
      }, 10)
    }
    // $.ajax({
    //   type: 'GET',
    //   url: store.root + 'api/products/offered',
    //   dataType: 'json',
    //   xhrFields: {
    //     withCredentials: true
    //   },
    //   success: function (response) {
    //     this.randomproducts = response
    //   }.bind(this)
    // })
  },
  methods: {
    startAgain () {
      this.invoice = {
        shipCosts: shippingRatesData.shipping_rates[0].price,
        products: []
      }
      this.invoice.customer = {
        sex: '',
        firstname: '',
        lastname: '',
        email: '',
        street: '',
        housenumber: '',
        housenumberr: '',
        housenumberaddition: '',
        zipcode: '',
        city: ''
      }
      this.progress = {
        step2: 0,
        step3: 0
      }
      this.currentStep = 0
    },
    GoToConfirm () {
      this.invoice.customer.housenumber = [this.invoice.customer.housenumberr, this.invoice.customer.housenumberaddition.toUpperCase()].filter(Boolean).join(' ')
      this.invoice.products = this.store.cart
      window.scrollTo(0, 0)
      this.currentStep++
    },
    removeSpaces () {
      this.invoice.customer.zipcode = this.invoice.customer.zipcode.replace(/ /g, '').toUpperCase()
    },
    handleInvoice () {
      this.sending = true
      // console.log(this.invoice)
      $.ajax({
        type: 'POST',
        url: store.root + 'api/Invoices',
        data: this.invoice,
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        sessionStorage.removeItem('winkelwagen')
        this.store.cart = []
        this.success = true
        this.error = false
        this.sending = false
        this.confirmed = false
        this.sended = true
        // window.location.replace("http://stackoverflow.com")
      }.bind(this))
      .fail(function (response) {
        // console.log(response)
        this.success = false
        this.error = true
      }.bind(this))
    }
  },
  watch: {
    invoice: {
      handler () {
        // step 2
        if (this.currentStep === 1) {
          this.progress.step2 = 0
          if (this.invoice.customer.sex.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.invoice.customer.firstname.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.invoice.customer.lastname.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.invoice.customer.email.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.invoice.customer.street.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.invoice.customer.housenumber.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.invoice.customer.zipcode.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.invoice.customer.city.length) {
            this.progress.step2 += 100 / 8
          }
          if (this.progress.step2 === 100) {
            if (this.$customerValidation.valid) {
              this.progress.step2 = 100
            } else {
              this.progress.step2 = 99
            }
          }
        }
      },
      deep: true
    },
    store: {
      handler: function (val, oldVal) {
        var self = this
        // step 1
        if (self.store.cart.length < 1) {
          self.progress.step1 = 0
        }
      },
      deep: true
    }
  },
  computed: {
    checkSex () {
      return (this.$customerValidation.sex.required && this.$customerValidation.sex.touched)
    },
    checkFirstname () {
      return (this.$customerValidation.firstname.required && this.$customerValidation.firstname.touched)
    },
    checkLastname () {
      return (this.$customerValidation.lastname.required && this.$customerValidation.lastname.touched)
    },
    checkEmail () {
      return (this.$customerValidation.email.email && this.$customerValidation.email.touched)
    },
    checkStreet () {
      return (this.$customerValidation.street.required && this.$customerValidation.street.touched)
    },
    checkHousenumber () {
      return (this.$customerValidation.housenumber.housenumber && this.$customerValidation.housenumber.touched)
    },
    checkZip () {
      return (this.$customerValidation.zip.touched && this.$customerValidation.zip.dutchzip)
    },
    checkCity () {
      return (this.$customerValidation.city.required && this.$customerValidation.city.touched)
    }
  }
}
</script>


// WEBPACK FOOTER //
// order.vue?0a325f08